export const HomepageComponentTrackingNames = {
  HomepageLatestListings: 'HomepageLatestListings',
  HomepageBumpedListings: 'HomepageBumpedListings',
  HomepageRecentlyViewedListings: 'HomepageRecentlyViewedListings',
} as const;
